import { ResponsiveContext, Box, Stack } from "grommet";
import React from "react";
import { AliasCard } from "./AliasCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AliasGrid = ({ aliases }) => {
    const size = React.useContext(ResponsiveContext);

    const BracketGridProps = size == "small" ? { rows: ["auto"], columns: ["1/2", "1/2"] } : { rows: ["auto"], columns: ["1/3", "1/3", "1/3"] };

    return (
        <>
            <Box direction="row" gap="medium" wrap>
                {aliases.map((alias) => (
                    <Box margin={{ bottom: "medium" }} key={alias.id}>
                        <Stack anchor="top-left">
                            <AliasCard alias={alias}></AliasCard>
                            {alias.archived && (
                                <Box pad={"xsmall"} background={"#c27b00"} round="3px">
                                    <FontAwesomeIcon size="lg" icon={["fad", "archive"]} color="black" />
                                </Box>
                            )}
                        </Stack>
                    </Box>
                ))}
            </Box>
        </>
    );
};
